import { Menu, Transition } from '@headlessui/react';
import dynamic from 'next/dynamic';
import { Fragment, useEffect, useRef, useState } from 'react';
import { cn } from '../../../../utils';

const MdKeyboardArrowDown = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdKeyboardArrowDown)
);

const CategoryDropdown = ({ menus, className, setSelected = () => {} }) => {
  const ref = useRef(null);
  const [selectedMenu, setSelectedMenu] = useState(null);

  useEffect(() => {
    if (selectedMenu === null) {
      setSelectedMenu(menus[0]);
    }
  }, [menus]);

  if (menus.length === 0 || selectedMenu === null) return null;
  return (
    <Menu as='div' className='relative inline-block text-left '>
      {({ open }) => (
        <>
          <Menu.Button
            ref={ref}
            className={cn(
              `flex cursor-pointer items-center justify-center space-x-[8px] rounded-none bg-light-grey px-[8px] py-[12.5px] text-center text-[16px] font-bold uppercase  md:px-[14px]`,
              className
            )}
          >
            <p className='line-clamp-1'>{selectedMenu.name}</p>
            <MdKeyboardArrowDown className='text-[20px] text-primary' />
          </Menu.Button>

          <Transition
            show={open}
            as={Fragment}
            enter='transition ease-out duration-100'
            enterFrom='transform opacity-0 scale-95'
            enterTo='transform opacity-100 scale-100'
            leave='transition ease-in duration-75'
            leaveFrom='transform opacity-100 scale-100'
            leaveTo='transform opacity-0 scale-95'
          >
            <Menu.Items
              static
              className='absolute left-0 z-[10000] w-[190px] origin-top-left !bg-white shadow-lg outline-none'
              ref={ref}
            >
              {menus.map((item, index) => (
                <Menu.Item key={index}>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? 'bg-gray-100' : ''
                      } dropdown-item w-full cursor-pointer px-3 py-2 text-start font-semibold uppercase hover:bg-gray-100`}
                      onClick={() => {
                        setSelectedMenu(item);
                        setSelected(item);
                      }}
                    >
                      {item.name}
                    </button>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};

export default CategoryDropdown;
